import axios from 'axios';

import { headers, salesServiceUrl } from '../../config';

export function getDpk() {
    return axios.get(`${salesServiceUrl}/dpk`, { headers: headers() });
}